<!-- w-[15rem] -->
<article (click)="navigatorVal ? navigateToPdp(dataSource.Url, $event) : {}" id="navigateToPdp-card"
  class="w-full  overflow-hidden rounded-xl card-item-1 shadow-sm bg-white !border !border-solid"
  [class]="isAffordableHotels ? '' : '!border !border-solid'" [class]="type === 2 ? 'h-[385px]' : 'h-[338px]'"
  *ngIf="dataSource; else loadingTemplate">
  <img class="w-full object-cover h-48" [ngSrc]="dataSource.PictureUrl == null ? 'a' : dataSource.PictureUrl"
    id="navigateToPdp-card" (click)="navigateToPdp(dataSource.Url, $event)" height="192" width="210"
    (error)="dataSource.PictureUrl = cdnUrl + '/images/no-image.jpg'"
    [alt]="!dataSource.PictureName ? dataSource?.Name : dataSource?.PictureName" />
  <div class="flex flex-col gap-1 my-1 justify-between px-4 py-2" style="height: calc(100% - 13rem)">
    <div class="flex flex-col">
      <h3 class="py-1 leading-none flex items-center " *ngIf="ecolodgeType !== 2">
        <a class="font-semi-bold text-sm leading-none line-clamp-1" id="navigateToPdp-card"
          (click)="navigateToPdp(dataSource?.Url, $event)" [href]="dataSource?.Url" [title]="dataSource.Name">
          {{ dataSource.Name }}
        </a>
      </h3>
      <h3 class="py-1 leading-none flex items-center " *ngIf="ecolodgeType == 2">
        <span (click)="navigateToPdp(dataSource?.Url, $event)"
          class="font-semi-bold text-sm leading-none line-clamp-1 cursor-pointer">
          {{ dataSource.Name }}
        </span>

      </h3>

      <div *ngIf="accommodation() === 'ecolodge'" class="flex items-center gap-2 my-1">
        <i class="ico-Profile text-xl text-muted"></i>
        <p class="text-xs text-black-300">{{ dataSource.Description }}</p>
      </div>




      <iho-stars-rate *ngIf="accommodation() !== 'ecolodge' && (dataSource?.Star?.GradeId !== 0 || dataSource?.Star)"
        [rating]="dataSource?.Star?.StarClassName | extractGrade"></iho-stars-rate>
      <div class="flex items-center gap-2" *ngIf="dataSource?.Address">
        <i class="ico-Location text-muted text-large"></i>
        <span class="text-muted text-xs">{{ dataSource?.Address?.Address }}</span>
      </div>
    </div>

    <div *ngIf="type === 2" class="flex flex-col gap-2">


      <div *ngIf="![0,'',null, undefined].includes(dataSource?.Score)" class="flex w-100 items-center">
        <div class="grade h-8 w-8 flex items-center justify-center">
          <span>{{ dataSource?.Score?.ScoreNumber }}</span>
        </div>
        <div class="ms-3" *ngIf="dataSource?.Score?.ScoreNumber > 0">
          <p class="font-bold text-blue-500 text-sm">{{ dataSource?.Score?.Text }}</p>
          <p class="text-xs">({{ dataSource?.Score?.Description }})</p>
        </div>
      </div>
    </div>

    <div class="flex w-full items-center justify-end min-h-5">
      <ng-container *ngIf="dataSource?.Price?.OldPrice && +dataSource?.Discount?.Discount >= 5">
        <span class="price-off text-black-200 mx-2 after:content-[''] line-through-price text-xs !font-normal">{{
          dataSource?.Price?.BoardPrice | toToman | number: '2.' }}</span>
        <div
          class="badge-precent text-xs font-semibold bg-green-50 w-[29px] h-[20px] px-2 py-1 rounded-[32px] flex justify-center items-center">
          <span class="text-green-800">{{ dataSource.Discount.Discount }}%</span>
        </div>
      </ng-container>
    </div>

    <div class="flex w-full items-center gap-1 justify-end">
      <span class="text-xs text-muted">{{ dataSource?.Price?.Nights }} شب</span>
      <span class="text-black-500 text-xl font-bold">
        {{
        (dataSource?.Price?.IhoPrice > 0) ? (dataSource.Price.IhoPrice | toToman | number: '2.') : (0)
        }}
      </span>
      <span class="text-xs text-muted">تومان</span>
    </div>
  </div>

</article>

<ng-template #loadingTemplate> component is loading... </ng-template>